export class TryOnProductClass {
    sku: string
    name: string
    imgURL: string
    isActive: boolean
    price: number
    promo: number
    unit?: "l" | "g"
    unitQuantity?: number 
    shadeColor: string
    shadeName: string
    description: string
    introduction: string
    type: TryOnType
    variants: Array<TryOnProductClass>
    actualVariant: string
    stock: number
    isVTOEnable: boolean
    isLiner: boolean
    isKholHigh: boolean
    parentSku: string
    parentName: string
    makeUpCategory?: string
    intensity?: Partial<Record<IntensityKeys, { value: number; min: number; max: number }>>

    constructor(_sku: string, _name: string, _stock: number, _isVTOEnable: boolean, _imgURL: string, _shadeColor: string, _shadeName: string, _isActive: boolean, _description: string, _price: number, _promo: number, _introduction: string, _type: TryOnType, _variants: Array<TryOnProductClass>, _actualVariant: string = "", _isLiner: boolean = false, _parentSku: string = "" , _parentName: string = "", _makeUpCategory: any = "", _unit?: "l" | "g", _unitQuantity?: number) {
        this.sku = _sku
        this.name = _name
        this.stock = _stock
        this.isVTOEnable = _isVTOEnable // Set this value to "true" if you want to test a product that is not enabled yet 
        this.imgURL = _imgURL
        this.isActive = _isActive
        this.shadeColor = _shadeColor
        this.shadeName = _shadeName
        this.description = _description
        this.price = _price
        this.promo = _promo
        this.unit = _unit
        this.unitQuantity = _unitQuantity
        this.introduction = _introduction
        this.type = _type
        this.variants = _variants
        this.actualVariant = _actualVariant
        this.isLiner = _isLiner
        this.isKholHigh = false
        this.parentSku  = _parentSku
        this.parentName = _parentName
        this.makeUpCategory = _makeUpCategory
    }

    addVariant = (product: TryOnProductClass) => {
        this.variants?.push(product)
    }
}

export type LightTryOnClass = {
    sku: string,
    category: string,
    imageURL: string,
    parentSku: string,
    actualVariant: string,
    intensity: { cheeks: number; lips: number }
}

export enum IntensityKeys {
    lips = "lips",
    cheeks = "cheeks"
}

export enum TryOnType {
    bundle = "bundle",
    variant = "variant",
    master = "master",
    look = "look",
    item = "item",
    error = "error"
}